import $ from 'jquery';
window.jQuery = $;
import 'jquery-modal';
const ScrollMagic = require('scrollmagic');
import _get from 'lodash.get';

// DO NOT REMOVE THIS COMMENTED OUT CODE PLEASE.
// UNCOMMENT TO SEE INDICATORS FOR WHERE SCROLL EVENTS ARE TRIGGERED FOR SCROLL MAGIC
// require('../../../../../node_modules/scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js');
require('imagesloaded');
import generateUrl from '../utils/generate_url_with_slide_util';
import ads from '../services/admanager';


class ModalShareButtons {
    constructor(originalUrl) {
        this.$shareModal = $('.share-modal-content');
        this.startHref = originalUrl;
        this.encodedStartHref = encodeURIComponent(this.startHref);
        this.$shareButtons = this.$shareModal.find('[class^="share-link-"]');
    }

    getCurrentURI() {
        return window.location.href;
    }

    updateShareURIs(currURI, newURI) {
        $.each(this.$shareButtons, (index, domEl) => {
            let $item = $(domEl);
            let href =  $item.attr('href');
            $item.attr('href', href.replace(currURI, newURI));
        });
    }

    restoreShareURIs() {
        this.updateShareURIs(this.updatedURI, this.encodedStartHref);
    }

    shareModalClick() {
        this.updatedURI = encodeURIComponent(this.getCurrentURI());
        this.updateShareURIs(this.encodedStartHref, this.updatedURI);
        this.$shareModal.modal({
            closeExisting: false,
            escapeClose: true,
            clickClose: true,
            closeClass: '.close-modal',
            modalClass: 'modal',
            spinnerHtml: null,
            showSpinner: true,
            showClose: true,
            fadeDuration: null,
            fadeDelay: 1.0
        });
    }
}

class Scroller {
    constructor(url) {
        this.controller = new ScrollMagic.Controller({ container: `.photo-gallery__modal[data-url="${url}"]` });
        this.counter = 0;
        this.scenes = [];
    }
    createScene(config) {
        const scene = new ScrollMagic.Scene(config)
        // DO NOT REMOVE THIS COMMENTED OUT CODE PLEASE.
        // UNCOMMENT TO SEE INDICATORS FOR WHERE SCROLL EVENTS ARE TRIGGERED FOR SCROLL MAGIC
        // .addIndicators({name: `${++this.counter}: (duration: ${config.duration})`})
        .addTo(this.controller);
        this.scenes.push(scene);
        return scene;
    }
    destroy() {
        this.scenes.forEach((scene) => {
            scene.destroy();
        });
        this.controller.destroy(true);
        delete this.scenes;
        delete this.controller;
    }
}

class PhotoGallery {
    constructor($slideshow, modal, slideNumberParam) {
        this.$slideshow = $slideshow.clone();
        this.$slides = $slideshow.find('.slide').clone();
        this.modalObj = modal;
        this.$modal = modal.$myself;
        this.slideIndexParam = slideNumberParam ? slideNumberParam - 1 : 0;
        this.closeButton = this.$modal.find('.photo-gallery__modal__close');
        this.modalShareButtons = new ModalShareButtons($slideshow.data('url'));
    }

    destroy() {
        this.$modal.remove();
        this.$slideshow.remove();
        this.$slides.remove();
        let properties = Object.getOwnPropertyNames(this);
        for (let i = 0; i < properties.length; i++) {
            let prop = properties[i];
            delete this[prop];
        }
    }
    buildFooter() {
        let shareButtonLauncher = `<button class="photo-gallery__modal__share"><span class="photo-gallery__modal__share__icon"></span>Share</button>`;
        this.closeButton.remove();
        this.closeButton.prepend('<span class="photo-gallery__modal__close__icon"></span>');
        return `<div class="photo-gallery__modal__menu">${shareButtonLauncher} ${this.closeButton[0].outerHTML}</div>`;

    }


    buildAdSlot() {
        return `<div class="ad-wrapper ad-wrapper-small ad-wrapper-small-inline no-border photo-gallery__modal__ad-wrapper"><div class="small-ad ad-unit" data-advertising="mobilerectangle"><div class='dart-ad'></div></div></div>`;
    }

    render() {
        let ua = _get(navigator, 'userAgent');
        let isAndroid;
        if  (ua) {
            ua = ua.toLowerCase();
            isAndroid = ua.indexOf("android") > -1;
        }
        let that = this; // eslint-disable-line consistent-this
        let logoLookup = {
            fastcodesign: '//d.fastcompany.net/asset_files/-/2016/05/19/Logos-white-47.svg',
            fastcocreate: '//c.fastcompany.net/asset_files/-/2016/05/19/Logos-white-46.svg',
            fastcoexist: '//a.fastcompany.net/asset_files/-/2016/05/19/Logos-white-48.svg',
            fastcompany: '//a.fastcompany.net/asset_files/-/2016/05/18/FC-Bug.svg'
        };
        let currentSite = bootstrap_obj.site.slug;
        let currentSiteUrl = bootstrap_obj.site.url;
        let htmlString = `<div class="photo-gallery__modal__nav-bar-wrapper">
            <a href="${currentSiteUrl}"><img class="photo-gallery__modal__nav-bar-logo photo-gallery__modal__nav-bar-logo--${currentSite}" src="${logoLookup[currentSite]}"/></a>
        </div>
        <div class="ad-wrapper ad-wrapper-small no-border mlb article header-ad-slideshow">
        <div class="small-ad ad-unit mobileleader-ad photo-gallery__modal__header-mlb" data-advertising="mobileleaderboard">
            <div class="dart-ad"></div>
        </div>
        </div>
        <div class="photo-gallery__modal__eyebrow">
            <p class="photo-gallery__modal__eyebrow-text left">Gallery</p>
        </div>
        <h1 class="photo-gallery__modal__hed">${this.$slideshow.data('title')}</h1>`;
        this.$slides.each((index, slide) => {
            let $slide = $(slide);
            let $img = $slide.find('img');
            let $video = $slide.find('video');
            let caption = $slide.data('caption');
            let slideNumber = index + 1;
            $slide.find('noscript').remove();
            $img.attr('src', $img.data('lazy'));


            if ($video.length && isAndroid) {
                $video.attr('onclick', 'this.play();');
            }

            let updatedCaption = $($.parseHTML(caption));
            updatedCaption.find('p').addClass('photo-gallery__modal__slide__caption__p');
            $slide.append(updatedCaption);
            // an ad every fourth spot
            if ((index - 2) % 3 === 0) {
                $slide.append(this.buildAdSlot());
            }

            htmlString += '<figure class="photo-gallery__modal__slide js-photo-gallery__modal__slide-' + slideNumber + '">' + $slide.html() + '</figure>';
        });
        this.$modal.append(htmlString);
        require('./media-scaler')({fitvidsSelector: `.photo-gallery__modal`});
        ads();

        let galleryScroller = new Scroller(this.$slideshow.data('url'));

        // find the margin-top of the first slide
        let offset = $('.photo-gallery__modal__slide').css('margin-top');
        this.$modal.imagesLoaded(function () {
            $('[class*="js-photo-gallery__modal__slide-"]').each(function (index, item) {
                let slideNumber = index + 1;
                let slideHeight = $(item).height();
                let sceneOffset = $(item).offset().top;
                // see here for playing around with config http://scrollmagic.io/examples/basic/scene_manipulation.html
                const configForScroll = {
                    triggerElement: '.js-photo-gallery__modal__slide-' + slideNumber,
                    triggerHook: 0.66,
                    offset: offset,
                    duration: slideHeight,
                    reverse: true
                };
                let scene = galleryScroller.createScene(configForScroll);
                scene.slideNumber = slideNumber;
                scene.slideIndex = index;
                scene.offset = sceneOffset;
                scene.on('enter', function (e) {

                    let slideIndex = e.currentTarget ? e.currentTarget.slideIndex : 1;
                    let originalUrl = window.location.pathname;
                    window.history.replaceState(null, '', window.location.protocol + '//' + window.location.host + '/' + generateUrl(originalUrl, slideIndex));

                });

            });

            if (that.slideIndexParam) {
                galleryScroller.controller.scrollTo(galleryScroller.scenes[that.slideIndexParam].offset - 30);
            }

        });
        const clickEvent = () => {
            const onClickCloseShareModal = () => {
                this.$modal.removeClass('photo-gallery__modal--no-scroll');
                this.modalShareButtons.$shareModal.find('.close-modal').off('click', onClickCloseShareModal);
            };
            this.$modal.addClass('photo-gallery__modal--no-scroll');
            this.modalShareButtons.shareModalClick();
            this.modalShareButtons.$shareModal.find('.close-modal').on('click', onClickCloseShareModal);
        };
        this.$menu = $(this.buildFooter());
        this.$modal.parent().append(this.$menu);


        this.$menu.find('.photo-gallery__modal__close').click(() => {
            this.$menu.remove();
            this.modalShareButtons.restoreShareURIs();
            $shareLauncher.off('click', clickEvent);
            galleryScroller.destroy();
            this.modalObj.close();
            this.modalObj = null;
            // Backbone.history.navigate(generateUrl(window.location.pathname, -1));
            window.history.replaceState(null, '', window.location.protocol + '//' + window.location.host + '/' + generateUrl(window.location.pathname, -1));
        });
        const $shareLauncher = this.$menu.find('.photo-gallery__modal__share');
        $shareLauncher.on('click', clickEvent);
    }
}

class Modal {
    constructor($slideshow, slideNumberParam) {
        this.$slideshow = $slideshow;
        this.slideNumberParam = slideNumberParam;
        this.hasModalBeenOpened = false;
        this.config = {
            clickClose: false,       // Allows the user to close the modal by clicking the overlay
            closeText: 'Close',     // Text content for the close <a> tag.
            closeClass: 'photo-gallery__modal__close',         // Add additional class(es) to the close <a> tag.
            modalClass: `photo-gallery__modal`
        };
    }

    open() {
        this.$myself = $(`<div data-url="${this.$slideshow.data('url')}"></div>`).modal(this.config);
        this.myPhotoGallery = new PhotoGallery(this.$slideshow, this, this.slideNumberParam);
        this.myPhotoGallery.render();
        $('html , body').addClass('photo-gallery__modal--no-scroll');
    }

    close() {
        this.myPhotoGallery.destroy();
        this.myPhotoGallery = null;
        this.$myself.remove();
        delete this.$myself;
        delete this.$slideshow;
        $('html , body').removeClass('photo-gallery__modal--no-scroll');
    }
}

class PhotoGalleryLauncher {
    constructor($item, slideNumberParam) {
        this.$slideshow = $item;
        this.slideNumberParam = slideNumberParam;
    }

    init() {
        let that = this; // eslint-disable-line consistent-this
        $(`.js-photo-gallery-launch-button[data-url="${this.$slideshow.data('url')}"]`).click(() => {
            let myModal = new Modal(that.$slideshow, that.slideNumberParam);
            myModal.open();
        });

        if (this.slideNumberParam !== 1 && this.slideNumberParam) {
            let myModal = new Modal(this.$slideshow, this.slideNumberParam);
            myModal.open();
        }
    }
}

export default PhotoGalleryLauncher;
